module.exports = __webpack_public_path__ + "static/img/6981_phase_function_Paper_PointsHejduk_Prediction.d7e8daf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6981_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ifT1
// module chunks = 0